import React from 'react'
import ContentHeader from '../../containers/ContentHeader'
import EcgLoader from '../../containers/EcgLoader'
import classes from './inventory.css'
import { HEADER_HEIGHT, BOTTOM_PADDING } from '../../constants'
import { checkInventoryFeatureEnabled } from '../../../configs'
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent'

class Inventory extends React.Component {
  UNSAFE_componentWillMount() {
    const { getInventoryData } = this.props
    getInventoryData()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }
  handleResize = () => {
    this.setState({ innerHeight: window.innerHeight })
  }
  sortLineItems = (a, b) => {
    const first = parseInt(a.connectionTemplateName.split('-')[0], 10)
    const second = parseInt(b.connectionTemplateName.split('-')[0], 10)
    let evaluated = 0
    if (first > second) evaluated = 1
    else if (first < second) evaluated = -1
    return evaluated
  }
  getInventoryCount = (allocated, generated, redeemed) => {
    const pending = this.getPendingCount(generated, redeemed)
    return allocated - pending - redeemed
  }
  getPendingCount = (generated, redeemed) => {
    return generated - redeemed
  }
  render() {
    const { dataIsFetching, dataLastUpdated, getInventoryData, me, inventory = { data: [] } } = this.props
    const heightStyle = { height: this.state.innerHeight - HEADER_HEIGHT - BOTTOM_PADDING }
    // only backofficeadmin can access the inventory page
    const isBackOfficeAdmin = me && me.data && me.data.profile.permissions.isBackOfficeAdmin
    if (!checkInventoryFeatureEnabled(me) || !isBackOfficeAdmin) {
      return (
        <div
          data-page="inventory"
          className={classes.inventory}
        >
          <AccessDeniedContent title="Inventory" />
        </div>
      )
    }
    return (
      <div data-page="dashboard" className={classes.inventory}>
        <ContentHeader
          isLoading={dataIsFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={() => getInventoryData(true)}
          showLastRefresh={!me.isFetching}
          showAddPatient={false}
          text="Inventory"
          me={me}
        />
        {me.isFetching && (
          <div className={classes.contentWrapper} style={heightStyle}>
            <EcgLoader />
          </div>
        )}
        {!me.isFetching && (
          <div className={classes['inventory-wrapper']} style={heightStyle}>
            <div className={classes['inventory-table']}>
              <div className={classes['inventory-header']}>
                <div className={classes['inventory-cell']}>
                  Short Description
                </div>
                <div className={classes['inventory-cell']}>
                  Inventory
                </div>
                <div className={classes['inventory-cell']}>
                  Pending
                </div>
                <div className={classes['inventory-cell']}>
                  Active
                </div>
              </div>
              <div className={classes['inventory-body']}>
                {(inventory.data || [])
                  .sort(this.sortLineItems)
                  .map((e, i) => (
                    <div className={classes['inventory-row']} key={i}>
                      <div className={classes['inventory-cell']}>
                        {e.connectionTemplateName}
                      </div>
                      <div className={classes['inventory-cell']}>
                        {this.getInventoryCount(e.allocatedConnectionsCount, e.generatedCodeCount, e.redeemedCodeCount)}
                      </div>
                      <div className={classes['inventory-cell']}>
                        {this.getPendingCount(e.generatedCodeCount, e.redeemedCodeCount)}
                      </div>
                      <div className={classes['inventory-cell']}>
                        {e.redeemedCodeCount}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default Inventory



// WEBPACK FOOTER //
// ./src/legacy/pages/Inventory/Inventory.jsx